import { Form } from "@redriver/cinnamon-mui";
import { getClients } from "./actions";

const ClientTypeAhead = (props) => (
  <Form.TypeAhead {...props} lookupAction={getClients} />
);

export default ClientTypeAhead;
